// plugins/passive-events.client.ts

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const addEventListener = EventTarget.prototype.addEventListener;

    EventTarget.prototype.addEventListener = function (
      type: string,
      listener: EventListenerOrEventListenerObject,
      options?: boolean | AddEventListenerOptions
    ) {
      let opts = options;

      // Force passive for scroll/touch/wheel events
      if (
        type === "touchstart" ||
        type === "touchmove" ||
        type === "wheel" ||
        type === "scroll"
      ) {
        if (typeof opts === "boolean") {
          opts = { capture: opts, passive: true };
        } else if (opts == null) {
          opts = { passive: true };
        } else if (typeof opts === "object" && !("passive" in opts)) {
          opts = { ...opts, passive: true };
        }
      }

      return addEventListener.call(this, type, listener, opts);
    };
  }
});
